import { render, staticRenderFns } from "./split-block.vue?vue&type=template&id=3e02fdc5&scoped=true"
import script from "./split-block.vue?vue&type=script&lang=js"
export * from "./split-block.vue?vue&type=script&lang=js"
import style0 from "./split-block.vue?vue&type=style&index=0&id=3e02fdc5&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e02fdc5",
  null
  
)

export default component.exports